export default [
  {
    timestamp: '1631123202',
    type: 'release',
  },
  {
    timestamp: '1595363945',
    type: 'hotfix',
  },
  {
    timestamp: '1580901059',
    type: 'release',
  },
  {
    timestamp: '1579783733',
    type: 'release',
  },
  {
    timestamp: '1579602424',
    type: 'release',
  },
  {
    timestamp: '1575649645',
    type: 'release',
  },
  {
    timestamp: '1572188581',
    type: 'release',
  },
  {
    timestamp: '1571056690',
    type: 'release',
  },
  {
    timestamp: '1570390158',
    type: 'release',
  },
  {
    timestamp: '1569836130',
    type: 'release',
  },
  {
    timestamp: '1569586520',
    type: 'hotfix',
  },
  {
    timestamp: '1569491921',
    type: 'release',
  },
  {
    timestamp: '1569243724',
    type: 'release',
  },
  {
    timestamp: '1568505600',
    type: 'release',
  },
  {
    timestamp: '1567036800',
    type: 'release',
  },
  {
    timestamp: '1564012800',
    type: 'release',
  },
]
